import { BrandSymbol, BrandSymbolKey, Icon, IconKey } from '@melio/penny';
import { CardNetwork, CardType, FundingSource } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

const cardNetworkToBrand: Record<Exclude<CardNetwork, 'other'>, BrandSymbolKey> = {
  amex: 'amex-logo',
  discover: 'discover',
  mastercard: 'mastercard',
  visa: 'visa',
};

const cardTypeToIcon: Record<CardType, IconKey> = {
  credit: 'credit-card',
  debit: 'debit-card',
};

export type FundingSourceIconProps = {
  fundingSource?: FundingSource;
};

export const FundingSourceIcon = forwardRef<FundingSourceIconProps>(({ fundingSource, ...props }, ref) => {
  if (fundingSource?.type === 'card') {
    const { details: card } = fundingSource;
    switch (card.network) {
      case 'other':
        return <Icon type={cardTypeToIcon[card.type]} {...props} ref={ref} />;
      default:
        return <BrandSymbol type={cardNetworkToBrand[card.network]} {...props} ref={ref} />;
    }
  }
  return <Icon type="bank" {...props} ref={ref} />;
});
FundingSourceIcon.displayName = 'FundingSourceIcon';
